"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateTime = exports.isDate = exports.validationRules = exports.getPlaceholder = exports.getIsInput = exports.isDisabled = exports.getAnswerItems = exports.FreeTextItemType = void 0;
exports.FreeTextItemType = {
    TEXT: "text",
    TEXTAREA: "textarea",
    NUMBER: "number",
    DATE_TIME: "datetime-local",
    DATE: "date",
    TEL: "tel",
};
var getAnswerItems = function (scenarioContentItems, data) {
    var answerItems = [];
    scenarioContentItems.map(function (scenarioContentItem) {
        var _a;
        answerItems.push({
            id: scenarioContentItem.id,
            title: scenarioContentItem.itemTitle,
            answer: (_a = data[scenarioContentItem.id]) !== null && _a !== void 0 ? _a : "",
            type: scenarioContentItem.data,
        });
    });
    return answerItems;
};
exports.getAnswerItems = getAnswerItems;
var isDisabled = function (isValid, isLoading, errors, isInput) {
    return !isValid || Object.keys(errors).length > 0 || isLoading || isInput;
};
exports.isDisabled = isDisabled;
var getIsInput = function (scenarioContentItems, data) {
    var isInput = true;
    scenarioContentItems.map(function (scenarioContentItem) {
        if (data === null || data === void 0 ? void 0 : data[scenarioContentItem.id]) {
            isInput = false;
        }
    });
    return isInput;
};
exports.getIsInput = getIsInput;
var getPlaceholder = function (type) {
    switch (type) {
        case exports.FreeTextItemType.NUMBER:
            return "数値を入力してください";
        case exports.FreeTextItemType.DATE_TIME || exports.FreeTextItemType.DATE:
            return "未選択";
        default:
            return "入力してください";
    }
};
exports.getPlaceholder = getPlaceholder;
var NOT_ALLOWED_BLANK = /.*\S+.*/;
var validationRules = function (isRequired) {
    return __assign(__assign({}, (isRequired && {
        required: {
            value: true,
            message: "必須項目です。",
        },
    })), { pattern: {
            value: NOT_ALLOWED_BLANK,
            message: "空白のみの入力は無効です。",
        } });
};
exports.validationRules = validationRules;
var isDate = function (type) {
    return type === exports.FreeTextItemType.DATE;
};
exports.isDate = isDate;
var isDateTime = function (type) {
    return type === exports.FreeTextItemType.DATE_TIME;
};
exports.isDateTime = isDateTime;
